var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCIconoOjoAbierto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#979797;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,38A30.2,30.2,0,0,1,8.2,32.1h0a7.4,7.4,0,0,1,0-11.9l.8-.6a28.5,28.5,0,0,1,34,0l.8.6a7.4,7.4,0,0,1,0,11.9A30.4,30.4,0,0,1,26,38Zm0-21.9a26.5,26.5,0,0,0-15.8,5.2l-.8.6a5.2,5.2,0,0,0-2.1,4.3,5,5,0,0,0,2.1,4.2h0a27.5,27.5,0,0,0,33.1,0,5.1,5.1,0,0,0,2.2-4.2,5.3,5.3,0,0,0-2.2-4.3l-.7-.6A26.5,26.5,0,0,0,26,16.1Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25.9,
    cy: 25.9,
    r: 5.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCIconoOjoAbierto);
export default __webpack_public_path__ + "static/media/c-icono-ojo-abierto.8eab1382.svg";
export { ForwardRef as ReactComponent };